import * as React from 'react'; 
import { Route } from 'react-router-dom'
import Dashboard from './Landing/Dashboard/Dashboard';
import AdmNotificaciones from './Notificaciones/AdmNotificaciones';
import AdmPublicaciones from './Publicaciones/AdmPublicaciones';
import AdmOrdenes from './Ordenes/AdmOrdenes';
import AdmSellers from './Sellers/AdmSellers';
import AdmUsuarios from './Usuarios/AdmUsuarios';
import ListRebates from './Rebates/ListRebates';
import AdmPlanes from './Planes/AdmPlanes';
import AdmTipoPublicaciones from './TipoPublicaciones/AdmTipoPublicaciones';
import AdmExportables from './Exportables/AdmExportables';
import AdmLiquidaciones from './Liquidaciones/Liquidaciones/AdmLiquidaciones';
import AdmNovedades from './Liquidaciones/Novedades/AdmNovedades';
import AdmConceptos from './Liquidaciones/Conceptos/AdmConceptos';
import AdmOrdenesProveedores from './Ordenes/Proveedores/AdmOrdenesProveedores'
export default class Container extends React.Component {
    render() {
        return (
            <div className="page-wrapper">
                <div className="container-fluid">
                    <Route exact path="/" component={Dashboard}/>
                    <Route path="/Notificaciones" component={AdmNotificaciones}/>
                    <Route path="/Sellers" component={AdmSellers}/>
                    <Route path="/Usuarios" component={AdmUsuarios}/>
                    <Route path="/Publicaciones" component={AdmPublicaciones}/>
                    <Route path="/Ordenes" component={AdmOrdenes} />
                    <Route path="/OrdenesProveedores" component={AdmOrdenesProveedores} />
                    <Route path="/Rebates" component={ListRebates}/>
                    <Route path="/Planes" component={AdmPlanes}/>
                    <Route path="/Tipo/Publicaciones" component={AdmTipoPublicaciones}/>
                    <Route path="/Exportables" component={AdmExportables}/>
                    <Route path="/Novedades" component={AdmNovedades}/>
                    <Route path="/Liquidaciones" component={AdmLiquidaciones}/>
                    <Route path="/Conceptos" component={AdmConceptos}/>
                </div>
            </div>
        );
    }
}